import React from "react";
import LigCustomModal from "../../../../assets/components/LigCustomModal";

const FinalStepPopUp = ({ show, closeHander }) => {
  const handleEnroll = () => {
    closeHander();
    window.location.href =
      "https://web.firooze.net/#/im/g1351217526?category=webchannel";
  };
  let content = (
    <>
      <p className="text-center py-4">جهت شرکت در آزمون حضوری کلیک کنید.</p>
      <div className="text-center">
        <button className="purplebutton" onClick={handleEnroll}>
          ثبت‌ نام
        </button>
      </div>
    </>
  );
  return (
    <LigCustomModal
      open={show}
      closeHandler={closeHander}
      dialogContent={content}
    />
  );
};

export default FinalStepPopUp;
